<template>
  <div
    class="modal fade"
    id="PriceModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">
            Importar Archivo - {{ subMenu.label }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="handleSubmit">
            <div class="mb-3">
              <label for="file" class="form-label">Subir Archivo Excel</label>
              <drag-drop-upload
                :file="formData.file"
                @file-dropped="handleFileDrop"
                @file-uploaded="handleFileUpload"
              />
            </div>
            <button
              type="submit"
              class="btn btn-primary w-100"
              :disabled="loading"
            >
              <span
                v-if="loading"
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              <span v-else>Importar {{ subMenu.label }}</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>

  <file-uploader
    ref="fileUploader"
    url="prices/import"
    :formData="formData"
    @success="handleSuccess"
    :hasTitle="false"
    @error="handleError"
  />
</template>

<script>
import { Modal } from "bootstrap";
import DragDropUpload from "@/components/DragDropUpload.vue";
import FileUploader from "@/components/shared/import/FileUploader.vue";
import Swal from 'sweetalert2';

import FileValidator from "@/utils/fileValidator.js";
import userConfirmation from "@/utils/userConfirmation.js";
import { closeLoadingAlert } from "@/utils/loadingAlert.js";

export default {
  name: "ModalFormPrecios",
  components: {
    DragDropUpload,
    FileUploader,
  },
  props: {
    subMenu: {
      type: Object,
      default: () => ({})
    }
  },
    emits: ['import-completed', 'export-completed', 'close-modal'],
  data() {
    return {
      loading: false,
      formData: {
        file: null,
        type: this.subMenu.value,
      },
      allowedExtensions: ['xlsx', 'xls', 'csv'],
    };
  },
  computed: {

  },
  methods: {
    handleFileDrop(file) {
      this.formData.file = file;
    },
    handleFileUpload(file) {
      this.formData.file = file;
    },
    async handleSubmit() {
      const validator = new FileValidator(this.formData.file, this.allowedExtensions);
      try {
        validator.validate();
      } catch (validationError) {
        this.handleError(validationError.message);
        return; 
      }
      
      const confirmed = await userConfirmation(`¿Está seguro que el archivo excel seleccionado es de ${this.subMenu.label} y desea importarlo?`);
      if (!confirmed) return;

     // showLoadingAlert();

      try {
        const response = await this.$refs.fileUploader.upload();
        closeLoadingAlert();
        // Manejar la respuesta directamente si el evento @success no se dispara
        if (response) {
          await this.handleSuccess(response);
        }
      } catch (error) {
        closeLoadingAlert();
        console.error("Upload failed:", error);
        // Pequeño delay para asegurar que el loading se cierre antes de mostrar el error
        await new Promise(resolve => setTimeout(resolve, 100));
        this.handleError(error);
      }
      
    },

    async handleSuccess(response) {
      console.log("handleSuccess called with:", response);
      // Verificar si el status es 202 (Accepted) o 200 (OK)
      const status = response?.status || response?.data?.status || (response?.response?.status);
      
      if (status === 202 || status === 200) {
        const result = await Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: 'Se cargaron los precios de forma correcta',
          confirmButtonText: 'OK',
        });
        
        // Cerrar el modal cuando el usuario presiona el botón de confirmación
        if (result.isConfirmed || result.isDismissed) {
          this.hideModal();
        }
      }
      this.$emit("import-completed", response);
    },
    
    showModal() {
      this.modal = new Modal(document.getElementById("PriceModal"));
      this.modal.show();
    },
    hideModal() {
      if (this.modal) {
        this.modal.hide();
      }
      // Asegurar que el modal se cierre también usando el método de Bootstrap
      const modalElement = document.getElementById("PriceModal");
      if (modalElement) {
        const modalInstance = Modal.getInstance(modalElement);
        if (modalInstance) {
          modalInstance.hide();
        }
      }
    },


    async handleError(error) {
      console.error("Upload failed:", error);
      
      // Verificar si es un error 403 (Forbidden)
      if (error?.response?.status === 403) {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No tiene permisos para cargar precios',
          confirmButtonText: 'OK',
        });
        return;
      }
      
      // Manejo de otros errores
      const errorMessage = error?.response?.data?.message || error?.message || error || 'Ocurrió un error al importar el archivo';
      await Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage,
        confirmButtonText: 'OK',
      });
    },
  },
  watch: {
    subMenu: {
      handler(newVal) {
        this.formData.type = newVal.value;
        this.formData.file = null;
      },
      deep: true,
      immediate: true
    }
  }, 
  mounted() {
    this.modal = new Modal(document.getElementById("PriceModal"));
  },
};
</script>

<style scoped>
.modal-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}
.modal-title {
  font-size: 1.25rem;
  font-weight: 500;
}
.modal-body {
  padding: 1.5rem;
}
.form-label {
  font-weight: 500;
}
.form-control,
.form-select {
  border-radius: 0.25rem;
}
.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
}
.btn-primary:hover {
  background-color: #0056b3;
  border-color: #004085;
}
.spinner-border {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}
</style>